import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    face.f.two,
    [
      face.u.one,
      face.m.one,
      face.u.two,
      face.m.pri,
    ],
    face.u.one,
    face.f.two,
  ],
  name: 'U Prem [CW]',
};
